import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Download, ExternalLink, X } from "lucide-react";
import { fileUrl } from "@/lib/api";

export const PdfViewerModal = ({ open, onOpenChange, url, title }) => {
  const viewUrl = fileUrl(url);
  const dlUrl = fileUrl(url, true);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-5xl w-[95vw] h-[90vh] flex flex-col p-0 gap-0 [&>button.absolute]:hidden" data-testid="pdf-viewer-modal">
        <DialogHeader className="p-4 border-b border-amber-200 bg-[#0a2540] text-white rounded-t-lg">
          <div className="flex items-center justify-between gap-4">
            <DialogTitle className="text-white font-serif-deva text-lg truncate">{title}</DialogTitle>
            <div className="flex gap-2 shrink-0">
              <a href={dlUrl} target="_blank" rel="noopener noreferrer" data-testid="pdf-modal-download">
                <Button size="sm" variant="secondary" className="gap-1">
                  <Download size={16} /> डाउनलोड
                </Button>
              </a>
              <a href={viewUrl} target="_blank" rel="noopener noreferrer" data-testid="pdf-modal-newtab">
                <Button size="sm" variant="secondary" className="gap-1">
                  <ExternalLink size={16} /> नया टैब
                </Button>
              </a>
              <button onClick={() => onOpenChange(false)} data-testid="pdf-modal-close"
                className="w-9 h-9 rounded-md bg-white/15 hover:bg-white/25 text-white flex items-center justify-center transition-colors" aria-label="बंद करें">
                <X size={18} />
              </button>
            </div>
          </div>
        </DialogHeader>
        <div className="flex-1 bg-slate-100 overflow-hidden">
          {viewUrl ? (
            <iframe title={title} src={viewUrl} className="w-full h-full" />
          ) : (
            <div className="flex items-center justify-center h-full text-slate-400">PDF उपलब्ध नहीं है</div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
